import * as React from 'react';

import { createIcon } from '../Icon';
export const ChevronDownIcon = createIcon(
  <polyline points="6 9 12 15 18 9" />,
  'ChevronDownIcon'
);
